// Phase 36: i18n — pure helpers (locale map, resolver). No React.
//
// The provider + hooks live in i18n/index.jsx which depends on React;
// this file is what tests import via Node's ESM loader (no .jsx, no
// transpilation step needed).
//
// Adding a new locale is purely additive: create locales/<code>.js with
// the same key set, register it in LOCALES below.

import zhHant from './locales/zh-Hant.js';
import zhHans from './locales/zh-Hans.js';
import en from './locales/en.js';
import ja from './locales/ja.js';

export const LOCALES = [
  { code: 'zh-Hant', label: '繁體中文', flag: '🇭🇰' },
  { code: 'zh-Hans', label: '简体中文',  flag: '🇨🇳' },
  { code: 'en',      label: 'English',   flag: '🇺🇸' },
  { code: 'ja',      label: '日本語',     flag: '🇯🇵' },
];

export const FALLBACK_LOCALE = 'zh-Hant';

const STRINGS = {
  'zh-Hant': zhHant,
  'zh-Hans': zhHans,
  'en':      en,
  'ja':      ja,
};

// Variables are interpolated with {name} syntax: resolve('hello', 'en', { name: 'Leo' })
// from "hello" → "Hello, {name}" → "Hello, Leo".
export function interpolate(template, vars) {
  if (!vars || !template) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
}

export function resolve(key, lang, vars, defaultValue) {
  const primary = STRINGS[lang] && STRINGS[lang][key];
  if (primary != null) return interpolate(primary, vars);
  const fallback = STRINGS[FALLBACK_LOCALE] && STRINGS[FALLBACK_LOCALE][key];
  if (fallback != null) return interpolate(fallback, vars);
  return defaultValue != null ? defaultValue : key;
}
